export default "__VITE_ASSET__OVc0AY6Y__"